<template>
  <!-- zvonce: obavestenja prijavljenog kupca (poruke za oglase, novi pratioci, odobren oglas, push vesti) -->
  <NotificationBell />

  <!-- Raniji sadrzaj zvonca (reklame za besplatan oglas, YouTube, Facebook i Google), zakomentarisan:
  <BDropdown variant="white"
   ref="dropdown"
   class="dropdown d-inline-block me-3"
   toggle-class="header-item noti-icon"
    right menu-class="dropdown-menu-lg dropdown-menu-end p-0">
    <template #button-content>
      <i class="esei icon-bell-solid"></i>
      <span class="badge bg-danger rounded-pill">{{ device.isMobileOrTablet ? 3 : 4 }}</span>
    </template>
    <div class="p-3">
      <div class="row align-items-center">
              <div class="col-12" @click="dropdownDisableTRefs()">
                <h5 class="m-0 font-size-16" >
                  <FreeAddNotifiationVue></FreeAddNotifiationVue>
                </h5>
              </div>

              <div class="col-12 mt-2" @click="dropdownDisableTRefs()">
                <h5 class="m-0 font-size-16">
                  <YoutubeNotifiationVue></YoutubeNotifiationVue>
                </h5>
              </div>
              <div class="col-12 mt-2" @click="dropdownDisableTRefs()">
                <h5 class="m-0 font-size-16">
                  <FacebookNotifiation></FacebookNotifiation>

                </h5>
              </div>
              <div class="col-12 mt-2" @click="dropdownDisableTRefs()" v-if="!device.isMobileOrTablet">
                <h5 class="m-0 font-size-16">
                  <GoogleNotifiation></GoogleNotifiation>

                </h5>
              </div>
            </div>
    </div>

  </BDropdown>
  -->
</template>

<script setup>
import NotificationBell from "~/components/notifications/NotificationBell.vue";

// import { BDropdown } from "bootstrap-vue-next";
//
// import FreeAddNotifiationVue from "~/components/widgets/YoutubeFacebookGoogeFreeAdd/FreeAddNotifiation.vue";
// import YoutubeNotifiationVue from "~/components/widgets/YoutubeFacebookGoogeFreeAdd/YoutubeNotifiation.vue";
// import GoogleNotifiation from "~/components/widgets/YoutubeFacebookGoogeFreeAdd/GoogleNotifiation.vue";
// import FacebookNotifiation from "~/components/widgets/YoutubeFacebookGoogeFreeAdd/FacebookNotifiation.vue";
//
// const device = useDevice();
//
// const dropdown = ref(null)
//
// const dropdownDisableTRefs = () =>{
//
//  dropdown.value.visible = false;
//
// }
</script>
